import toolsService from '../services/tools.service';

export const tools = {
  state: {
    periods: [],
    systemDate: {},
    applicationDefaults: [],
    backdatingLimitPeriods: [],
    unitsRounding: [],
    identity: []
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allPeriods: (state) => state.periods,
    currentSystemDate: (state) => state.systemDate,
    unconfirmedPeriods: (state) => {return [state.periods.filter(a => a.CheckerID == 0),[state.periods.title = "Periods"]]},
    allApplicationDefaults: (state) => state.applicationDefaults,
    allBackdatingLimitPeriods: (state) => state.backdatingLimitPeriods,
    allUnitsRounding: (state) => state.unitsRounding,
    identity: (state) => state.identity,
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PERIODS

  createPeriod({ commit }, data) {
      return toolsService.createPeriod(data).then(
        response => {
          commit('newPeriod', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllPeriods({ commit }) {
      return toolsService.getAllPeriods().then(
        response => {
          commit('setPeriods', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getSystemDate({ commit }) {
      return toolsService.getSystemDate().then(
        response => {
          commit('setSystemDate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePeriod({ commit }, data) {
      return toolsService.updatePeriod(data.PeriodID, data).then(
        response => {
          commit('updPeriod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deletePeriod({ commit }, data) {
      return toolsService.deletePeriod(data.PeriodID).then(
        response => {
          commit('dltPeriod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION DEFAULTS

    getAllApplicationDefaults({ commit }) {
      return toolsService.getAllApplicationDefaults().then(
        response => {
          commit('setApplicationDefaults', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllBackdatingLimitPeriods({ commit }) {
      return toolsService.getAllBackdatingLimitPeriods().then(
        response => {
          commit('setBackdatingLimitPeriods', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllUnitsRounding({ commit }) {
      return toolsService.getAllUnitsRounding().then(
        response => {
          commit('setUnitsRounding', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateApplicationDefaults({ commit }, data) {
      return toolsService.updateApplicationDefaults(data.AppsDefaultsId, data).then(
        response => {
          commit('updApplicationDefaults', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SYSTEM IDENTITY

    getIdentity({ commit }) {
      return toolsService.getIdentity().then(
        response => {
          commit('setIdentity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateIdentity({ commit }, data) {
      return toolsService.updateIdentity(data.OrgId, data).then(
        response => {
          commit('updIdentity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************
  mutations: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PERIODS

    setPeriods: (state, periods) => (state.periods = periods),
    setSystemDate: (state, newDate) => (state.systemDate = newDate),
    newPeriod: (state, newPeriod) => state.periods.unshift(newPeriod.period),
    updPeriod: (state, updatedPeriod) => {
      const index = state.periods.findIndex(periods => periods.PeriodID === updatedPeriod.PeriodID);
      if (index !== -1) {
        state.periods.splice(index, 1, updatedPeriod);
      }
    },
    dltPeriod: (state, Period) => {
      const index = state.periods.findIndex(periods => periods.PeriodID === Period.PeriodID);
      if (index !== -1) {
        state.periods.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION DEFAULTS

    setApplicationDefaults: (state, defaults) => (state.applicationDefaults = defaults),
    setBackdatingLimitPeriods: (state, periods) => (state.backdatingLimitPeriods = periods),
    setUnitsRounding: (state, rounding) => (state.unitsRounding = rounding),
    updApplicationDefaults: (state, updatedDefaults) => {
      const index = state.applicationDefaults.findIndex(applicationDefaults => applicationDefaults.AppsDefaultsId === updatedDefaults.AppsDefaultsId);
      if (index !== -1) {
        state.applicationDefaults.splice(index, 1, updatedDefaults);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION DEFAULTS

    setIdentity: (state, newIdentity) => (state.identity = newIdentity),
    updIdentity: (state, updatedIdentity) => {
      const index = state.identity.findIndex(identity => identity.OrgId === updatedIdentity.OrgId);
      if (index !== -1) {
        state.identity.splice(index, 1, updatedIdentity);
      }
    },
  },
}
